import { render, staticRenderFns } from "./VLeaseDeadlinesModal.vue?vue&type=template&id=20b9d5d4&"
import script from "./VLeaseDeadlinesModal.vue?vue&type=script&lang=js&"
export * from "./VLeaseDeadlinesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports